import { SectionStyleField, SectionToneField } from "../section-style.fields";

const ProcessStepsFields = {
  heading: {
    type: "custom",
    label: "Heading",
    metadata: {
      source: "ai",
      description: "Section heading for the process steps (e.g. 'How It Works')",
      seo: true,
      key: "processSteps.heading",
    },
  },
  subheading: {
    type: "custom",
    label: "Subheading",
    metadata: {
      source: "ai",
      description: "Brief introduction to the process (15-20 words)",
      seo: true,
      key: "processSteps.subheading",
    },
  },
  layout: {
    type: "radio",
    label: "Layout",
    options: [
      { label: "Vertical Timeline", value: "vertical" },
      { label: "Horizontal Timeline", value: "horizontal" },
      { label: "Numbered List", value: "numbered" },
    ],
    metadata: {
      source: "manual",
    },
  },
  // Bold sets each step's number in big type.
  variant: SectionStyleField,
  // Dark puts the steps on a dark band, for a page that needs one between light sections.
  tone: SectionToneField,
  steps: {
    type: "array",
    label: "Process Steps",
    metadata: {
      source: "ai",
      description: "List of 3-6 steps explaining the service process",
      seo: true,
      key: "processSteps.list",
    },
    getItemSummary: (item: { title: string; step: number }) =>
      `Step ${item.step}: ${item.title}`,
    arrayFields: {
      step: {
        type: "number",
        label: "Step Number",
        metadata: {
          description: "The step number (1, 2, 3, etc.)",
        },
      },
      title: {
        type: "text",
        label: "Step Title",
        metadata: {
          description: "Brief title for this step",
        },
      },
      description: {
        type: "textarea",
        label: "Description",
        metadata: {
          description: "Explanation of what happens in this step (20-40 words)",
        },
      },
    },
    defaultItemProps: {
      step: 1,
      title: "New Step",
      description: "Description of this step",
    },
  },
  accentColor: {
    type: "text",
    label: "Accent Color (optional)",
    metadata: {
      source: "manual",
      description: "Custom color for step numbers",
    },
  },
  backgroundColor: {
    type: "text",
    label: "Background Color (optional)",
    metadata: {
      source: "manual",
    },
  },
} as const;

export { ProcessStepsFields };
